/* @jsx h */
import { Layout } from "@app/vue/components/index";
import {
  AuthProvider,
  ToastProvider,
  BrandingProvider,
  TrpcProvider,
} from "@app/vue/providers/index";
import deLangURL from "../../translations/de.json?url";
import enLangURL from "../../translations/en.json?url";
import frLangURL from "../../translations/fr.json?url";
import itLangURL from "../../translations/it.json?url";
import kaLangURL from "../../translations/ka.json?url";
import { LocalizationProvider } from "@lemmonhq/uikit";
import {
  defineComponent,
  onErrorCaptured,
  onMounted,
  onUnmounted,
  ref,
  h,
} from "vue";

export const App = defineComponent({
  name: "App",
  setup() {
    const err = ref<null | Error>(null);
    onErrorCaptured((e) => {
      //console.log("e", e);
      err.value = e;
    });
    const onVisibilityChange = () => {
      //console.log("visibilitychange", JSON.stringify(document.visibilityState));
    };
    const onFocus = () => {
      //console.log("window focus");
    };
    const onBlur = () => {
      //console.log("window blur");
    };
    onMounted(() => {
      document.addEventListener("visibilitychange", onVisibilityChange);
      window.addEventListener("focus", onFocus);
      window.addEventListener("blur", onBlur);
    });
    onUnmounted(() => {
      document.removeEventListener("visibilitychange", onVisibilityChange);
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("blur", onBlur);
    });

    return () => {
      // render reload button so user doesn't have to restart mobile app
      // console.log("err", err.value);
      if (err.value) {
        return (
          <div class="h-screen w-screen flex flex-col gap-4 items-center justify-center  px-6">
            <div class="text-4xl text-center">Uh-oh! Something went wrong!</div>
            <button
              onClick={(e) => {
                e.preventDefault();
                window.location.reload();
              }}
              class="btn btn-primary btn-lg"
            >
              reload
            </button>
          </div>
        );
      }
      return (
        <LocalizationProvider
          files={{
            de: deLangURL,
            en: enLangURL,
            fr: frLangURL,
            it: itLangURL,
            ka: kaLangURL,
          }}
        >
          <TrpcProvider>
            <BrandingProvider>
              <ToastProvider>
                <AuthProvider>
                  <Layout />
                </AuthProvider>
              </ToastProvider>
            </BrandingProvider>
          </TrpcProvider>
        </LocalizationProvider>
      );
    };
  },
});
